import { cellRenderAdminMessageStatus, cellRenderParseDataAndTimeWithSeconds } from '../../../utils/functions';

const cMetDataGrid = [
  {
    dataField: 'docId',
    caption: 'ID документа',
    dataType: 'string'
  },
  {
    dataField: 'msgCounter',
    caption: 'ID сообщения',
    dataType: 'string'
  },
  {
    dataField: 'msgDateTime',
    caption: 'Время',
    dataType: 'date',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  {
    dataField: 'msgId',
    caption: 'Тип',
    dataType: 'number'
  },
  {
    dataField: 'msgDesc',
    caption: 'Описание типа',
    dataType: 'string'
  },
  { dataField: 'msgGuid',
    caption: 'msgGuid',
    dataType: 'string'
  },
  {
    dataField: 'status',
    caption: 'Статус',
    dataType: 'number',
    cellRender: cellRenderAdminMessageStatus
  },
  { dataField: 'msgRemark',
    caption: 'msgRemark',
    dataType: 'string'
  },
  {
    dataField: 'modDateTime',
    caption: 'Время изменения',
    dataType: 'datetime',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  { dataField: 'clientId',
    caption: 'clientId',
    dataType: 'string'
  }
];

export default cMetDataGrid;
